import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getApiBase } from "../lib/apiBase";

export default function AdminProtectedRoute({ children }) {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let active = true;
    const API = getApiBase();

    fetch(`${API}/api/admin-auth/me`, { credentials: "include" })
      .then((response) => {
        if (!active) return;
        setStatus(response.ok ? "allowed" : "denied");
      })
      .catch(() => {
        if (active) setStatus("denied");
      });

    return () => {
      active = false;
    };
  }, []);

  if (status === "loading") {
    return <div className="flex min-h-screen items-center justify-center text-slate-600" data-testid="admin-protected-loading">Vérification de l’accès…</div>;
  }

  if (status === "denied") {
    return <Navigate replace to="/admin/login" />;
  }

  return children;
}